import React, { useState, useEffect } from 'react';
import './CookieConsent.css';
import CookieIcon from '@mui/icons-material/Cookie';
import CloseIcon from '@mui/icons-material/Close';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setTimeout(() => setIsVisible(true), 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-consent">
      <div className="cookie-content">
        <div className="cookie-icon">
          <CookieIcon />
        </div>
        <div className="cookie-text">
          <h3>We use cookies</h3>
          <p>
            We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic. 
            By clicking "Accept All", you consent to our use of cookies.
          </p>
        </div>
        <div className="cookie-actions">
          <button onClick={handleAccept} className="cookie-btn cookie-accept">
            Accept All
          </button>
          <button onClick={handleDecline} className="cookie-btn cookie-decline">
            Decline
          </button>
        </div>
        <button onClick={handleDecline} className="cookie-close" aria-label="Close">
          <CloseIcon />
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
